import authApi from '../../api/apiAuth'
import apiProfit from "../../api/apiProfit";
import jwt_decode from 'jwt-decode'

const state = {
    jwtToken: localStorage.getItem('jwt'),
    tokenStatus: !!localStorage.getItem('jwt'),
    userRole: localStorage.getItem('role'),
    userReferer: localStorage.getItem('userReferer'),
    userName: localStorage.getItem('userName'),
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    userDeposit: localStorage.getItem('userDeposit'),
    userDepRate: localStorage.getItem('userDepositRate'),
    userDepositRate: localStorage.getItem('userDepositRate'),
    userDueAmount: localStorage.getItem('userDueAmount'),
    userCreditAmount: localStorage.getItem('userCreditAmount'),
    userManagerGoal: localStorage.getItem('userManagerGoal'),
    userManagerGoalAchieved: 0,
    paymentData: null,
    paypalModal: false
}

const getters = {
    getToken: (state) => {
        return state.jwtToken
    },
    getTokenStatus: (state) => {
        return state.tokenStatus
    },
    getUserRole: (state) => {
        return state.userRole
    },
    getUserReferer: (state) => {
        return state.userReferer
    },
    getUserName: (state) => {
        return state.userName
    },
    getCurrentUser: (state) => {
        return state.currentUser
    },
    checkIfUserIsAdmin: (state) => {
        return state.userRole === 'Admin'
    },
    checkIfUserIsManager: (state) => {
        return state.userRole === 'Manager'
    },
    getUserDeposit(state) {
        return state.userDeposit
    },
    getUserDepositRate(state) {
        return state.userDepositRate
    },
    getUserDepRate(state) {
        return state.userDepRate
    },
    getUserDueAmount(state) {
        return state.userDueAmount
    },
    getUserManagerGoal(state) {
        return state.userManagerGoal
    },
    getUserManagerGoalAchieved: (state) => {
        return state.userManagerGoalAchieved
    },
    getCurrentUserCreditAmount: (state) => {
        return state.userCreditAmount
    },
    getPaymentData: (state) => {
        return state.paymentData
    },
    getPaypalModal: (state) => {
        return state.paypalModal
    }
}

const actions = {
    validateToken: ({ commit, getters }) => {
        if ( getters.getTokenStatus ) {
            const decoded = jwt_decode(getters.getToken)
            const currentTime = parseInt(Date.now() / 1000)
            const timeDifference = decoded.exp - currentTime
            if ( timeDifference > 0 && timeDifference < 3600 ) {
                authApi
                    .refreshToken()
                    .then(response => {
                        commit('updateToken', response.data.token)
                    })
                    .catch(err => console.log(err))
            } else if ( timeDifference < 0 ) {
                commit('removeToken')
            }
        }
    },
    checkUpdateUserRole: ({ commit }) => {
        authApi
            .checkMeRequest()
            .then(response => {
                commit('updateRole', response.data.user.roles[0].name)
            })
            .catch(err => console.log(err))
    },
    fetchCurrentLoginUser: function (context) {
        context.dispatch('setStatusLoading')
        authApi
            .checkMeRequest()
            .then(response => {
                context.commit('updateCurrentUser', response.data)
                context.dispatch('setStatusLoaded')
            })
            .catch(err => console.log(err))
    },
    fetchCurrentUserManagerGoalAchieved: ({ commit }) => {
        apiProfit
            .getManagerGoalAchieved()
            .then(response => {
                console.log(response.data)
               commit('updateCurrentUserManagerGoalAchieved', response.data)
            })
            .catch(err => console.log(err))
    },
    payment: ({ commit }, data) => {
        authApi
            .addDeposit(data)
            .then(response => {
                console.log(response.data)
               commit('setPayment', response.data)
                commit('updateUserDeposit', response.data.balance)
            })
            .catch(err => console.log(err))
    },
    openPaypal: ({ commit }, status) => {
        commit('openPaypal', status)
    }

}

const mutations = {
    updateCurrentUserManagerGoalAchieved: (state, data) => {
        state.userManagerGoalAchieved = data
    },
    updateToken(state, newToken) {
        localStorage.setItem("jwt", JSON.stringify(newToken))
        state.jwtToken = newToken
        state.tokenStatus = true
    },
    removeToken(state) {
        localStorage.removeItem("jwt")
        state.jwtToken = ''
        state.tokenStatus = false
    },
    updateRole(state, newRole){
        localStorage.setItem("role", newRole)
        state.userRole = newRole
    },
    updateUserReferer(state, userReferer){
        localStorage.setItem("userReferer", userReferer)
        state.userReferer = userReferer
    },
    removeReferer(state, newRole){
        localStorage.removeItem("userReferer", newRole)
        state.userReferer = ''
    },
    removeRole(state, newRole){
        localStorage.removeItem("role", newRole)
        state.userRole = ''
    },
    updateUserName(state, newName){
        localStorage.setItem("userName", newName)
        state.userName = newName
    },
    removeUserName(state, newName){
        localStorage.removeItem("userName", newName)
        state.userName = ''
    },
    updateCurrentUser(state, newUser){
        localStorage.setItem("currentUser", JSON.stringify(newUser))
        state.currentUser = newUser
    },
    updateUserDeposit(state, newValue) {
        localStorage.setItem("userDeposit", newValue)
        state.userDeposit = newValue
    },
    updateUserDepositRate(state, newValue) {
        localStorage.setItem("userDepositRate", newValue)
        state.userDepositRate = newValue
    },
    updateUserDepRate(state, newValue) {
        state.userDepRate = newValue
    },
    updateUserManagerGoal(state, newValue) {
        localStorage.setItem("userManagerGoal", newValue)
        state.userManagerGoal = newValue
    },
    removeUserDeposit(state){
        localStorage.removeItem("userDeposit", null)
        state.userDeposit = null
    },
    removeUserDepositRate(state){
        localStorage.removeItem("userDepositRate", null)
        state.userDeposiRatet = null
    },
    updateUserDueAmount(state, newValue) {
        localStorage.setItem("userDueAmount", newValue)
        state.userDueAmount = newValue
    },
    removeUserDueAmount(state){
        localStorage.removeItem("userDueAmount", null)
        state.userDueAmount = null
    },
    removeUserCreditAmount: (state) => {
        localStorage.removeItem("userCreditAmount", null)
        state.userCreditAmount = null
    },
    removeUserManagerGoal(state) {
        localStorage.setItem("userManagerGoal", null)
        state.userManagerGoal = null
    },
    setPayment(state, data) {
        state.paymentData = data;
    },
    openPaypal(state, status) {
        state.paypalModal = status;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js